<template>
  <div>
    <div v-show="currentVisibled"
         v-detach
         :class="wrapClasses"
         @click="$_onWrapClick"
    >
      <div v-if="!draggable" :class="maskClasses"></div>
      <div :class="modalClasses">
        <div ref="dragContent" :class="dialogClasses" :style="[widthStyle, dragStyle]">
          <transition :name="transitionName">
            <div ref="content"
                 :class="contentClasses"
                 :style="heightStyle"
            >
              <div v-if="currentHeaderVisibled" :class="headerClasses" @mousedown="dragStart">
                <slot name="header">
                  <div :class="titleClasses">{{ title }}</div>
                </slot>
                <div v-if="closable"
                     class="close"
                     @click="$_onCloseClick"
                >
                  <slot name="close">
                    <span>×</span>
                  </slot>
                </div>
              </div>
              <div ref="modalBody"
                   :class="bodyClasses"
              >
                <slot></slot>
              </div>
              <div v-if="currentFooterVisibled"
                   :class="footerClasses"
              >
                <slot name="footer">
                  <t-button color="secondary"
                            @click="$_onCloseClick"
                  >{{ localeCancelText }}</t-button>
                  <t-button color="primary"
                            :loading="currentLoading"
                            @click="$_onOkClick"
                  >{{ localeOkText }}</t-button>
                </slot>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import Locale from '../../mixins/locale'
import Detach from '../../directives/detacher'

const PREFIX_MODAL_CLASS = `${PREFIX_CLASS}modal`
const modalMinWidth = 768
const clientWidth = document.body.clientWidth
const StartXY = { x: 0, y: 0, left: 0, top: 0 }
export default {
  name: 'TModal',
  directives: {
    Detach
  },
  mixins: [Locale],
  props: {
    visibled: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    draggable: {
      type: Boolean,
      default: false
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    customClasses: {
      type: String,
      default: ''
    },
    modalWrapClasses: {
      type: String,
      default: ''
    },
    customStyles: {
      type: Object,
      default: () => {}
    },
    transitionName: {
      type: String,
      default: 'ease'
    },
    width: {
      type: [Number, String],
      default: '520px'
    },
    height: {
      type: [Number, String],
      default: 'auto'
    },
    title: {
      type: String,
      default: ''
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    headerVisibled: {
      type: Boolean,
      default: true
    },
    footerVisibled: {
      type: Boolean,
      default: true
    },
    ok: {
      type: Function,
      default: () => {}
    },
    cancel: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      onlyOne: false,
      currentVisibled: false,
      currentHeaderVisibled: true,
      currentFooterVisibled: true,
      currentNoPadding: false,
      currentLoading: false,
      orgOverflowStyle: '',
      onAsyncShow: true,
      screenWidth: '',
      dragContent: {
        top: 0,
        left: 0

      }
    }
  },
  computed: {
    widthStyle() {
      let width
      let screenWidth = Number(clientWidth)
      if (screenWidth <= modalMinWidth) {
        width = 'auto'
      } else {
        if (typeof this.width === 'number') {
          width = `${this.width}px`
        } else {
          width = this.width
        }
      }
      return Object.assign({
        width
      }, this.customStyles)
    },
    dragStyle() {
      let { left, top } = this.dragContent
      if ((left || top) && this.draggable) {
        return {
          position: 'absolute',
          left: left + 'px',
          top: top + 'px'
        }
      } else {
        return {}
      }
    },
    localeCancelText() {
      if (this.cancelText === '') {
        return this.t('t.modal.cancelText')
      } else {
        return this.cancelText
      }
    },
    localeOkText() {
      if (this.okText === '') {
        return this.t('t.modal.okText')
      } else {
        return this.okText
      }
    },
    wrapClasses() {
      return [
        `${PREFIX_MODAL_CLASS}-wrap`,
        {
          [`${PREFIX_MODAL_CLASS}-noMask`]: this.draggable,
          [`${this.modalWrapClasses}`]: this.modalWrapClasses
        }
      ]
    },
    footerClasses() {
      return `${PREFIX_MODAL_CLASS}-footer`
    },
    bodyClasses() {
      return [
        `${PREFIX_MODAL_CLASS}-body`,
        {
          'p-0': this.currentNoPadding
        }
      ]
    },
    titleClasses() {
      return `${PREFIX_MODAL_CLASS}-title`
    },
    headerClasses() {
      return `${PREFIX_MODAL_CLASS}-header`
    },
    heightStyle() {
      let height
      if (typeof this.height === 'number') {
        height = `${this.height}px`
      } else {
        height = this.height
      }
      return {
        height
      }
    },
    contentClasses() {
      return `${PREFIX_MODAL_CLASS}-content`
    },
    maskClasses() {
      return `${PREFIX_MODAL_CLASS}-backdrop fade show`
    },
    modalClasses() {
      return `${PREFIX_MODAL_CLASS} d-block show`
    },
    dialogClasses() {
      return [
        `${PREFIX_MODAL_CLASS}-dialog`,
        {
          [`${this.customClasses}`]: (this.customClasses !== ''),
          [`${PREFIX_MODAL_CLASS}-dialog-drag`]: this.draggable
        }
      ]
    }
  },
  watch: {
    visibled(val) {
      this.currentVisibled = val
      if (val === false) {
        document.body.style.overflow = this.orgOverflowStyle
        this.reset()
      } else {
        /*
         * 修正dropdown组件中的popper.js没有刷新位置的问题
         * 由于window的resize事件没触发导致popper.js没有刷新位置
         */
        if (this.onlyOne === false) {
          this.onlyOne = true
          this.$_fireEvent(window, 'resize')
        }

        document.body.style.overflow = 'hidden'
      }
    }
  },
  created() {
    this.orgOverflowStyle = document.body.style.overflow
    this.currentHeaderVisibled = this.headerVisibled
    this.currentFooterVisibled = this.footerVisibled
    this.currentVisibled = this.visibled
    this.currentNoPadding = this.noPadding
    document.body.addEventListener('keydown', this.$_onDocKeyDown)
  },
  beforeDestroy() {
    document.body.style.overflow = this.orgOverflowStyle
    document.body.removeEventListener('keydown', this.$_onDocKeyDown)
  },
  methods: {
    dragStart(e) {
      if (!this.draggable) return
      StartXY.x = e.pageX
      StartXY.y = e.pageY
      let rect = this.$refs.dragContent.getBoundingClientRect()
      StartXY.left = rect.left
      StartXY.top = rect.top
      document.addEventListener('mousemove', this.modalMove)
      document.addEventListener('mouseup', this.removeEvent, { once: 1 })
    },
    removeEvent() {
      document.removeEventListener('mousemove', this.modalMove)
      document.removeEventListener('mouseup', this.removeEvent)
    },
    modalMove(e) {
      let moveX = e.pageX - StartXY.x
      let moveY = e.pageY - StartXY.y
      this.dragContent.left = StartXY.left + moveX
      this.dragContent.top = StartXY.top + moveY
    },
    $_fireEvent(target, eventName) {
      if (target.dispatchEvent) {
        let event = document.createEvent('HTMLEvents')
        event.initEvent(eventName, false, true)
        target.dispatchEvent(event)
      } else {
        target.fireEvent(`on${eventName}`) // ie10
      }
    },
    $_onDocKeyDown(event) {
      if (this.currentVisibled && this.closable) {
        if (event.keyCode === 27) {
          this.$_onCloseClick()
          /*
           * 2.x中 esc 会导致以click方式打开的poptip没有销毁
           * 3.0中还未测试，先保留
           */
          this.$_fireEvent(document.body, 'click')
        }
      }
    },
    $_onCloseClick() {
      if (this.currentVisibled === true) {
        this.currentVisibled = false
        this.onAsyncShow = false
        this.$emit('update:visibled', false)
        if (this.cancel) {
          this.cancel()
        }
      }
    },
    $_isPromise(obj) {
      return typeof obj === 'object' && (typeof obj.then === 'function')
    },
    $_onOkClick() {
      if (this.currentVisibled === true && this.currentLoading === false) {
        if (this.ok) {
          let result = this.ok()
          if (this.$_isPromise(result)) {
            this.currentLoading = true
            this.onAsyncShow = true
            result.then((val) => {
              if (this.onAsyncShow) {
                if (val !== false) {
                  this.currentVisibled = false
                  this.$emit('update:visibled', false)
                }
                this.currentLoading = false
              }
            })
          } else if (result !== false) {
            this.currentVisibled = false
            this.$emit('update:visibled', false)
          }
        } else {
          this.currentVisibled = false
          this.$emit('update:visibled', false)
        }
      }
    },
    $_onWrapClick() {
      if (this.$refs.content && this.$refs.content.contains(event.target) === true) {
        return false
      } else {
        if (this.maskClosable) {
          this.$_onCloseClick()
        }
      }
    },
    reset() {
      this.currentLoading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/modal/modal.vue